import { Providers } from '../../../../enums/providers';
import { CountryUIConfigName } from '../constants';
import { CountryUIFeature } from '../country-ui-feature';

export const USCountryUIConfig = [
  new CountryUIFeature(CountryUIConfigName.ShippingSuppliesLinkEnabled),
  new CountryUIFeature(CountryUIConfigName.PreferredWalletedProvidersIds, {
    labelProvidersIds: [Providers.UPSWallet.labelProviderId, Providers.USPS.labelProviderId],
  }),
];
